import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  byModule: {},
  loading: false,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    loadingSettings: (state) => {
      state.loading = true;
    },
    loadingSettingsDone: (state) => {
      state.loading = false;
    },
    setSettings: (state, action) => {
      state.byModule = action.payload;
    },
  },
});

export const { loadingSettings, loadingSettingsDone, setSettings } =
  settingsSlice.actions;

export default settingsSlice.reducer;
